import type { PostHog } from 'posthog-js'

const useiCloudReady = (): PostHog | undefined => {
    return typeof window !== 'undefined' ? ((window as any).posthog as PostHog) : undefined
}

export default useiCloudReady
